// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { SearchRequest } from "../../../data/app-core/search-request";
import { EnvelopeDocument } from "../base/envelope-document";

export class SearchRequestDocument extends EnvelopeDocument {
	public override Item: SearchRequest = new SearchRequest();
}